import {
  createDirectus,
  authentication,
  rest,
  login,
  readMe,
  logout,
} from "@directus/sdk";

const client = createDirectus(location.origin)
  .with(authentication("cookie"))
  .with(rest());

async function loginCRM(email, password) {
  const result = await client.request(
    login({ email, password }, { mode: "session" })
  );
  return result;
}
async function logoutCRM() {
  const result = await client.request(logout({ mode: "session" }));
  return result;
}

async function validate() {
  try {
    const res = await client.request(readMe());

    return res;
  } catch {
    return "";
  }
}
export default { loginCRM, validate, logoutCRM };
